import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  CircularProgress,
  InputBase,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { ArrowRightCircleIcon } from "../../assets/Icon/ArrowIcon";
import CustomTable from "../../components/common-components/CustomTable";

import { useSelector } from "react-redux";
import { useAppDispatch } from "../../stores/store";

import CommonPagination from "../../components/common-components/CommonPagination";

import { useNavigate } from "react-router-dom";

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";
import NoOrdersFound from "../../components/common-components/NoOrdersFound";
import SearchDropdown from "../../components/common-components/SearchDropdown";
import { ButtonWrapper } from "../../components/style/modalStyle";
import { getCompanyList, getOrderList } from "../../stores/incorporation";
import { formatDate, sortData } from "../../utils/functions";

type SortOrder = "asc" | "desc";
const LlcEinOrders = () => {
  const dispatch = useAppDispatch();
  const {
    data: agentList,
    status,
    total_records,
    companyList,
    companyListStatus,
  } = useSelector((state: any) => state.incorporation);

  const { userId } = useSelector((store: any) => store.auth);
  const [page, setPage] = useState(1);
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState<any>(null);
  const [order, setOrder] = useState<SortOrder>("asc");
  const [orderBy, setOrderBy] = useState("");
  const [searchQuery, setSearchQuery] = useState<any>("");
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);
  const [debouncedSearch, setDebouncedSearch] = useState<string>("");
  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);
  const [sortedList, setSortedList] = useState<any>();
  const navigate = useNavigate();
  const dropdownRef = useRef<any>(null);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 600);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  useEffect(() => {
    fetchAgents();
  }, [page, limit]);

  const fetchAgents = () => {
    const offset = (page - 1) * limit;

    dispatch<any>(
      getOrderList({
        userId: userId,
        offset,
        limit,
        search: selectedCompany || "",
        start_date: startDate ? startDate.format("YYYY-MM-DD") : "",
      }),
    );
  };
  const fetchCompanyList = () => {
    dispatch<any>(
      getCompanyList({
        search: debouncedSearch,
        product_id: 2,
      }),
    );
  };
  useEffect(() => {
    fetchCompanyList();
  }, [debouncedSearch]);

  // console.log(selectedCompany,"selectedCompany");
  const handleSearchChange = async (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    // event.preventDefault();
    setSearchQuery(event.target.value);
    // await dispatch<any>(
    //   getCompanyList({
    //     search: event.target.value,
    //   })
    // );
    setPage(1);
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    setCurrentPage(newPage);
  };

  const LlcStatus: Record<
    number,
    { label: string; bgColor: string; textColor: string }
  > = {
    0: { label: "Pending", bgColor: "#FFF5DB", textColor: "#E7AB12" },

    1: { label: "Under Review", bgColor: "#FFF5DB", textColor: "#E7AB12" },
    2: { label: "Submitted", bgColor: "#EAF1FA", textColor: "#2977CC" },
    3: { label: "Completed", bgColor: "#D9FFD2", textColor: "#3DC826" },
    4: { label: "Completed", bgColor: "#D9FFD2", textColor: "#3DC826" },
    5: { label: "Completed", bgColor: "#D9FFD2", textColor: "#3DC826" },
    6: { label: "Completed", bgColor: "#D9FFD2", textColor: "#3DC826" },
    7: { label: "Completed", bgColor: "#D9FFD2", textColor: "#3DC826" },
    99: { label: "Deactivated", bgColor: "#ff000020", textColor: "#ff0000" },
  };

  const EinStatus: Record<
    number,
    { label: string; bgColor: string; textColor: string }
  > = {
    0: { label: "Pending", bgColor: "#FFF5DB", textColor: "#E7AB12" },
    1: { label: "Pending", bgColor: "#FFF5DB", textColor: "#E7AB12" },
    2: { label: "Pending", bgColor: "#FFF5DB", textColor: "#E7AB12" },
    3: { label: "Pending", bgColor: "#FFF5DB", textColor: "#E7AB12" },
    4: {
      label: "Ready For Signature",
      bgColor: "#FFF5DB",
      textColor: "#E7AB12",
    },
    5: { label: "Under Review", bgColor: "#FFF5DB", textColor: "#E7AB12" },
    6: { label: "Submitted", bgColor: "#EAF1FA", textColor: "#2977CC" },
    7: { label: "Completed", bgColor: "#D9FFD2", textColor: "#3DC826" },
    99: { label: "Deactivated", bgColor: "#ff000020", textColor: "#ff0000" },
  };

  const handleClose = () => {
    setOpenModal(false);
  };
  const handleSubmit = () => {
    dispatch<any>(
      getOrderList({
        userId: userId,
        offset: 0,
        limit: 10,
        search: selectedCompany,
        start_date: startDate ? startDate.format("YYYY-MM-DD") : "",
      }),
    );
    setIsFilterApplied(true);
    // Close the popup after applying filter
    if (dropdownRef.current) {
      dropdownRef.current.close();
    }
    // setIsFilterApplied(false);
  };
  // const formik = useFormik({
  //   initialValues: {
  //     searchQuery: "",
  //   },
  //   onSubmit: (values) => {
  //     console.log(values);
  //   },
  // });
  // const filteredAgents = Array.isArray(agentList) ? agentList.filter((item: any) =>
  //   item?.sku?.toLowerCase().includes(searchQuery.toLowerCase())
  // ) : [];

  // console.log(agentList,"agentList");

  const handleCancelClick = () => {
    if (dropdownRef.current) {
      dropdownRef.current.close();
    }
    setSelectedCompany(null);
    setSearchQuery("");
    setStartDate(null);
    dispatch<any>(
      getOrderList({
        userId: userId,
        offset: 0,
        limit: 10,
        search: "",
        start_date: "",
      }),
    );
  };
  const handleApplyNow = () => {
    window.open("https://theitin.com/", "_blank");
  };
  const handleSortOrder = (column: any) => {
    if (orderBy === column) {
      setOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setOrderBy(column);
      setOrder("asc");
    }
  };

  useEffect(() => {
    const sort = sortData(agentList, orderBy, order);
    if (sort?.length) {
      setSortedList(sort);
    }
  }, [agentList]);

  // const sortedList = sortData(agentList, orderBy, order);

  return (
    <>
      <StyledBox sx={{ paddingY: "16px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            padding: "20px",
            "@media (min-width: 600px)": {
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            },
          }}
        >
          <Title>LLC + EIN Applications</Title>

          <SearchDropdown
            ref={dropdownRef}
            selectedCompany={selectedCompany}
            isFilterApplied={isFilterApplied}
            startDate={startDate}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                padding: "30px 20px",
              }}
            >
              <Typography
                variant="h4"
                sx={{ fontSize: "16px", fontWeight: "500", mb: "6px" }}
              >
                Order Created
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                {/* <DemoContainer components={['DatePicker']}> */}
                <DatePicker
                  label=""
                  value={startDate}
                  onChange={(val) => {
                    if (val) {
                      setStartDate(dayjs.utc(val.format("YYYY-MM-DD")));
                    }
                    setIsFilterApplied(true);
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "medium",
                      sx: {
                        flex: 1,
                        // height: "10px",
                        maxWidth: "340px",
                        boxShadow: "0px 2px 4px 0px #D1DEEB33",
                        "& .MuiOutlinedInput-root": {
                          height: "45px",
                          "& fieldset": {
                            border: "0.5px solid #EAF1FA",
                            borderRadius: "8px",
                          },
                          "&:hover fieldset": {
                            border: "0.5px solid #EAF1FA",
                            borderRadius: "8px",
                          },
                          "&.Mui-focused fieldset": {
                            border: "0.5px solid #2977CC",
                          },
                        },
                      },
                      // onClick: () => setInvoiceDateOpen(true),
                    },
                  }}
                />
                {/* </DemoContainer> */}
              </LocalizationProvider>

              <Typography
                variant="h4"
                sx={{
                  fontSize: "16px",
                  fontWeight: "500",
                  mb: "6px",
                  marginTop: "10px",
                }}
              >
                Company Name
              </Typography>
              <SearchWrapper>
                <SearchIcon />
                <StyledInputBase
                  placeholder="Search company name..."
                  inputProps={{ "aria-label": "search" }}
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </SearchWrapper>
              <Box
                sx={{
                  height: "160px",
                  minHeight: "50px",
                  overflowY: "auto",
                  overflowX: "hidden",
                  display: "flex",
                  flexDirection: "column",
                  "&::-webkit-scrollbar": {
                    width: "6px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "3px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#c1c1c1",
                    borderRadius: "3px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    background: "#a8a8a8",
                  },
                }}
              >
                {companyListStatus === "loading" ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: "50px",
                    }}
                  >
                    <ListLoadingNew />
                  </Box>
                ) : companyList?.length > 0 ? (
                  companyList?.map((item: any, index: number) => (
                    <Box
                      key={index}
                      onClick={() => setSelectedCompany(item)}
                      sx={{
                        cursor: "pointer",
                        p: 1,
                        borderRadius: "8px",
                        backgroundColor:
                          selectedCompany === item ? "#e3f2fd" : "transparent", // light blue highlight
                        "&:hover": {
                          backgroundColor: "#f1f1f1",
                        },
                      }}
                    >
                      <Typography>{item}</Typography>
                    </Box>
                  ))
                ) : (
                  <Box
                    sx={{
                      height: "160px",
                      minHeight: "50px",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <Typography sx={{ p: 1, color: "gray" }}>
                      No results found
                    </Typography>
                  </Box>
                )}
              </Box>
              {/* {debouncedSearch && companyList?.length === 0 && (
                 <Typography sx={{ p: 1, color: "gray" }}>No results found</Typography>
               )} */}
              <ButtonWrapper
                onClick={handleClose}
                isTax
                isSearch
                sx={{ marginTop: "10px" }}
              >
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  sx={{ width: "120px" }}
                  disabled={!selectedCompany && !startDate}
                >
                  {false ? (
                    <CircularProgress
                      size={24}
                      sx={{
                        "& svg": {
                          stroke: "url(#gradientColor)",
                        },
                      }}
                    />
                  ) : (
                    "Apply"
                  )}
                </Button>
                <Button variant="text" onClick={handleCancelClick}>
                  {"Cancel"}
                </Button>
              </ButtonWrapper>
            </Box>
          </SearchDropdown>

          {/* <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                "@media (min-width: 600px)": {
                  flexDirection: "row",
                  alignItems: "center",
                },
              }}
            > */}

          {/* 
            {/* </Box> */}
        </Box>

        <CustomTable
          headings={[
            "ORDER ID",
            "COMPANY",
            "ORDER CREATED",
            "LLC STATUS",
            "EIN STATUS",
            "ACTION",
          ]}
          isSort
          sortOrder={handleSortOrder}
          data={sortedList}
          orderBy={orderBy}
          order={order}
        >
          {status === "loading" ? (
            <TableRow>
              <TableCell
                colSpan={5}
                sx={{
                  textAlign: "center",
                  padding: "40px",
                  // height: "200px",
                  // verticalAlign: "middle"
                }}
              >
                <ListLoadingNew isheight />
              </TableCell>
            </TableRow>
          ) : agentList && sortedList?.length > 0 ? (
            <>
              {sortedList?.map((item: any, index: number) => {
                const timestamp = item?.created_at;
                const date = timestamp ? timestamp.split("T")[0] : "-";
                return (
                  <TableRow key={index} sx={{ height: "50px" }}>
                    <TableCell
                      sx={{
                        width: "15%",
                      }}
                    >
                      <Typography>{item?.order_id || "-"}</Typography>
                    </TableCell>
                    <TableCell
                    // sx={{
                    //   width: "40%",
                    // }}
                    >
                      <Typography>{item?.sku || "-"}</Typography>
                    </TableCell>
                    <TableCell
                    // sx={{
                    //   width: "40%",
                    // }}
                    >
                      <Typography>{formatDate(date)}</Typography>
                    </TableCell>
                    <TableCell
                      sx={{
                        width: "20%",
                      }}
                    >
                      <Box
                        sx={{
                          minWidth: "113px",
                          width: "auto",

                          textAlign: "center",
                          display: "inline-block",
                          padding: "9px",
                          // paddingx: "9px",
                          borderRadius: "6px",
                          fonsize: "12px",
                          fontWeight: "600",

                          backgroundColor:
                            LlcStatus[item?.status]?.bgColor || "#ccc", // Default color
                          color: LlcStatus[item?.status]?.textColor || "#000", // Default text color
                          whiteSpace: "nowrap",
                          cursor: "pointer",
                        }}
                      >
                        {LlcStatus[item?.status]?.label || "Unknown"}
                      </Box>
                    </TableCell>
                    <TableCell
                      sx={{
                        width: "20%",
                      }}
                    >
                      <Box
                        sx={{
                          minWidth: "113px",
                          width: "auto",

                          textAlign: "center",
                          display: "inline-block",
                          padding: "9px",
                          // paddingx: "9px",
                          borderRadius: "6px",
                          fonsize: "12px",
                          fontWeight: "600",
                          backgroundColor:
                            EinStatus[item?.status]?.bgColor || "#ccc",
                          color: EinStatus[item?.status]?.textColor || "#000",
                          whiteSpace: "nowrap",
                          cursor: "pointer",
                        }}
                      >
                        {EinStatus[item?.status]?.label || "Unknown"}
                      </Box>
                    </TableCell>

                    <TableCell
                      sx={{
                        width: "15%",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          gap: 1,
                        }}
                      >
                        {item?.id && item?.status !== 99 && (
                          <Box
                            onClick={() =>
                              navigate(
                                item?.status === 0
                                  ? `/incorporation/${item?.id}`
                                  : `/incorporation-detail/${item?.id}`,
                              )
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <ArrowRightCircleIcon />
                          </Box>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
            </>
          ) : (
            <TableRow>
              <TableCell colSpan={5}>
                <NoOrdersFound
                  title="No LLC + EIN Applications Found"
                  showButton={isFilterApplied ? false : true}
                  breakWords={["your"]}
                  handleApplyNow={handleApplyNow}
                  subTitle={
                    isFilterApplied
                      ? ""
                      : "It looks like no LLC + EIN applications have been submitted yet. Start your application today to set up your business seamlessly."
                  }
                />
              </TableCell>
            </TableRow>
          )}
        </CustomTable>
        {/* Pagination */}
        {Math.ceil(total_records / limit) > 1 && (
          <Box sx={{ display: "flex", justifyContent: "end", mt: 3 }}>
            <CommonPagination
              currentPage={page}
              totalPages={Math.ceil(total_records / limit)}
              onPageChange={handlePageChange}
            />
          </Box>
        )}
      </StyledBox>
    </>
  );
};

export default LlcEinOrders;

const StyledBox = styled(Box)({
  background: "#ffffff",
  boxShadow: "0px 2px 40px 0px #DDE3EA33",
  borderRadius: "10px",
  // padding: "16px",
  margin: "16px",
});

const Title = styled(Typography)({
  color: "#01060B !important",
  fontSize: "20px !important",
  fontWeight: "600 !important",
});

const SearchWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  background: "#F6F9FD",
  color: "#6B6B6B",
  borderRadius: "8px",
  padding: "5px 10px",
  "&:hover": {
    background: "#F6F9FD",
  },
});

const StyledInputBase = styled(InputBase)({
  minWidth: "300px",
  padding: "3px",
});
